export default class PointController {

	constructor(resource) {
		this._resource = resource;
	}

	  async get() {
		try {
		  let response = await this._resource(`point`).get();
		  return response.body;
		} catch (error) {
		  console.log(error);
		}
	  }  
}
